import React, { Component } from 'react';
import global from './store/global';
import { useParams } from 'react-router-dom';
/**
 * 路由转换，返回iframe和微前端路由
 * @param {*} routes
 * @returns
 */
export const convertRoutes = function (routes = []) {
    const result = {
        microApp: [],
        iframeApp: []
    };

    for (const item of routes) {
        if (item.iframe) result.iframeApp.push(item);
        else result.microApp.push(item);
    }
    return result;
};
export class CommomComponet extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = { pathName: '' };
    // }
    // /**
    //  *
    //  * @param {*} nextProps  与componentWillReceiveProps的nextProps参数相同。即改变后的Props
    //  * @param {*} preState  发生改变前的state中各数据的值。
    //  * @returns
    //  */
    // static getDerivedStateFromProps(nextProps, preState) {
    //     if (nextProps.location.pathname !== preState.pathName) {
    //         return { pathName: nextProps.location.pathname }
    //     }
    //     return null
    // }
    render() {
        return <></>;
    }
}


export const IframeComponet = function (src) {
    const { id } = useParams();
    let href = `${src.src}?pageId=${id}`;

    return <iframe style={{ width: '100%', height: '100%', border: 'none' }} title='iframe' src={href}></iframe>;

};
/**
 * 通过url地址获取域名
 * @param {*} url
 * @returns
 */
export const getDomainFromUrl = function (url) {
    return url ? url.split('/')[2] : '';
};
/**
 * 注册iframe子应用消息通信
 */
export class RegisterIframeMessage {
    constructor(iframeRoutes) {
        this.originObj = {};
        this.iframeSourceObj = {};
        this.registerMessage(iframeRoutes);
    }

    /**
     * 获取所有iframe子应用
     */
    get iframeSource() {
        return this.iframeSourceObj;
    }

    /**
     * 触发向子应用iframe发送消息
     * @param {*} message
     */
    emitMessage(message) {
        let iframeObj = this.iframeSource;

        for (const key in iframeObj) {
            if (Object.hasOwnProperty.call(iframeObj, key)) {
                const element = iframeObj[key];

                element.postMessage(message, key);
            }
        }
    }

    /**
     * iframe子应用变更主应用的值
     * @param {*} message
     */
    setData(message) {
        if (message['method'] === 'setData') {
            let childData = message.data;

            global.setGlobalState(childData);
        }
    }

    /**
     * 注册iframe消息监听
     * @param {*} iframeRoutes
     */
    registerMessage(iframeRoutes) {
        let originObj = this.originObj,
         iframeSourceObj = this.iframeSourceObj;

        iframeRoutes.filter(item => {
            let origin = item.entry,
             domain = getDomainFromUrl(origin);

            return domain && (originObj[domain] = item);
        });
        window.addEventListener('message', (e) => {
            let { origin, source, data } = e,
             domain = getDomainFromUrl(origin);

            if (domain && originObj.hasOwnProperty.call(originObj, domain)) {// eslint-disable-line
                iframeSourceObj[origin] = source;
                this.setData(data);
            }
        });
    }
}
